import React, { useCallback, useEffect, useState } from 'react';
import { classes } from './ExpressCheckoutButtons.st.css';
import { useExpressCheckoutButtonsData } from '../provider/useExpressCheckoutButtonsData';
import loadable from '@loadable/component';
import { useFunctionResultObservation } from '@wix/function-result-observation';
import { RESULT_PROP_NAME } from '../utils/consts';
import { getEstimatedPaymentData } from '../utils/getEstimatedPaymentData';
import { Skeleton } from './Skeleton';
import { ExpressCheckoutButtonsState, getState } from '../utils/ExpressCheckoutButtonsState';

// @ts-expect-error - @types/loadable__component has nested React types incompatible with React 18
const CashierExpressCheckoutWidgetLazy = loadable({
  resolved: {},
  chunkName() {
    return "CashierExpressCheckoutWidget";
  },
  isReady(props) {
    const key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: () => import(/* webpackChunkName: "CashierExpressCheckoutWidget" */'@wix/cashier-express-checkout-widget'),
  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync(props) {
    const id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@wix/cashier-express-checkout-widget");
    }
    return eval('require.resolve')("@wix/cashier-express-checkout-widget");
  }
}, {
  resolveComponent: components => components.CashierExpressCheckoutWidget
});
export let ExpressCheckoutButtonsDataHooks = /*#__PURE__*/function (ExpressCheckoutButtonsDataHooks) {
  ExpressCheckoutButtonsDataHooks["root"] = "ExpressCheckoutButtonsDataHooks.root";
  ExpressCheckoutButtonsDataHooks["loader"] = "ExpressCheckoutButtonsDataHooks.loader";
  return ExpressCheckoutButtonsDataHooks;
}({});

/* eslint-disable sonarjs/cognitive-complexity */
export const ExpressCheckoutButtons = _ref => {
  let {
    layout,
    theme,
    buttonStyle,
    isShippable,
    estimatedTotal,
    canStartPayment = true,
    dataHook,
    currency,
    withLoader = false,
    isMobile = false
  } = _ref;
  const data = useExpressCheckoutButtonsData();
  const {
    withObservation
  } = useFunctionResultObservation({
    resultPropName: RESULT_PROP_NAME
  });
  const {
    legacyCurrency,
    locale,
    domain,
    meta,
    demoMode,
    onCancel,
    onClick,
    setCurrency,
    isExpressSupported
  } = data ?? {};
  useEffect(() => {
    if (currency && setCurrency) {
      setCurrency(currency);
    }
  }, [currency, setCurrency]);
  const onShippingContactSelected = withObservation(data, 'onShippingContactSelected');
  const onPaymentAuthorized = withObservation(data, 'onPaymentAuthorized');
  const onShippingMethodSelected = withObservation(data, 'onShippingMethodSelected');
  const getInitialPaymentData = withObservation(data, 'getInitialPaymentData');
  const onClickHandler = useCallback(() => {
    onClick();
    return {
      canceled: !canStartPayment
    };
  }, [canStartPayment, onClick]);
  const [numberOfButtons, setNumberOfButtons] = useState(undefined);
  const shouldRender = data && Number(estimatedTotal) !== 0 && isExpressSupported;
  const isWidgetLoading = numberOfButtons === undefined;
  const isDataLoading = estimatedTotal === undefined;
  const isLoading = (isWidgetLoading || isDataLoading) && shouldRender;
  const state = getState({
    isLoading,
    shouldRender,
    numberOfButtons
  });
  useEffect(() => {
    if (!data) {
      return;
    }
    if (state === ExpressCheckoutButtonsState.LOADING) {
      data.onStateChange({
        state,
        numberOfButtons: undefined
      });
    } else {
      data.onStateChange({
        numberOfButtons: numberOfButtons ?? 0,
        state
      });
    }
  }, /* eslint-disable react-hooks/exhaustive-deps*/[Boolean(data), state]);
  if (!shouldRender) {
    return null;
  }
  const {
    orderItems,
    paymentBreakdown,
    paymentAmount
  } = getEstimatedPaymentData(estimatedTotal);
  const shouldShowCashierWidgetWrapper = layout === 'horizontal' && numberOfButtons && numberOfButtons > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook ?? ExpressCheckoutButtonsDataHooks.root,
    "data-wix-hideable": true,
    className: isLoading ? classes.hide : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: shouldShowCashierWidgetWrapper ? classes.cashierWidgetWrapper : undefined
  }, /*#__PURE__*/React.createElement(CashierExpressCheckoutWidgetLazy, {
    currency: currency ?? legacyCurrency,
    demoMode: demoMode,
    theme: theme,
    buttonStyle: buttonStyle,
    layout: layout,
    locale: locale,
    domain: domain,
    meta: meta,
    paymentLabel: "forApplePay",
    orderItems: orderItems,
    requestShipping: isShippable,
    paymentBreakdown: paymentBreakdown,
    paymentAmount: paymentAmount,
    onPaymentMethodsAmountInit: buttonsCount => {
      setNumberOfButtons(buttonsCount);
    },
    onPaymentAuthorized: paymentInfo => onPaymentAuthorized(paymentInfo, isShippable),
    onCancel: () => onCancel(),
    onClick: onClickHandler,
    onShippingMethodSelected: shippingMethod => onShippingMethodSelected(shippingMethod),
    onShippingContactSelected: shippingContact => onShippingContactSelected(shippingContact),
    getInitialPaymentData: () => getInitialPaymentData()
  }))), withLoader && isLoading ? /*#__PURE__*/React.createElement("div", {
    "data-hook": ExpressCheckoutButtonsDataHooks.loader,
    className: classes.skeletonWrapper
  }, /*#__PURE__*/React.createElement(Skeleton, {
    layout: layout,
    isMobile: isMobile
  })) : null);
};
//# sourceMappingURL=ExpressCheckoutButtons.js.map